import cx from 'classnames';
import React from 'react';

export default function FormText({ children, className }) {
  return (
    <p className={cx("text-sm y-gray", className)} style={{ color: '#787878' }}>{children}</p>
  )
}
